import { canEditPlaylist } from "frontend/src/features/playlists";
import { paths } from "frontend/src/pages/paths/index";
export var getPlaylistTooltipAndURL = function (playlist) {
    if (!playlist) {
        return { tooltip: "", url: "" };
    }
    var isPlaylistEditable = canEditPlaylist(playlist);
    var playlistTooltipTitle = isPlaylistEditable
        ? "Редактировать"
        : "Просмотреть";
    var playlistURL = isPlaylistEditable
        ? paths.business.owner.playlists.edit(playlist.id)
        : paths.business.owner.playlists.view(playlist.id);
    return {
        tooltip: playlistTooltipTitle,
        url: playlistURL,
        isEditable: isPlaylistEditable,
    };
};
